<div class="component-viewer">
  <h1 class="mat-h1">Create Outing Iteration</h1>
  <mat-card>
    <mat-card-content>
      <div class="container-fluid">
        <div class="row">
          <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        </div>
        <div class="row">
          <h2>{{outing.name}}</h2>
        </div>
      </div>
      <form [formGroup]="form" (ngSubmit)="onSubmit(form)">
        <div class="container-fluid">
          <div class="row">
            <div class="col-3">
              <mat-form-field class="w-100">
                <mat-label>Start Date</mat-label>
                <input required matInput [matDatepicker]="startPicker" formControlName="startDateOnly" />
                <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
                <mat-error *ngIf="form.get('startDateOnly').errors?.required">Start Date is required
                </mat-error>
                <mat-error *ngIf="form.get('startDateOnly').errors?.validationErrors">
                  {{ form.get("startDateOnly").errors?.validationErrors}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field class="w-100">
                <mat-label>Start Time</mat-label>
                <input required matInput [matTimepicker]="startTimePicker" formControlName="startTimeOnly" />
                <mat-timepicker #startTimePicker />
                <mat-timepicker-toggle [for]="startTimePicker" matSuffix />
                <mat-error *ngIf="form.get('startTimeOnly').errors?.required">Start Time is required
                </mat-error>
                <mat-error *ngIf="form.get('startTimeOnly').errors?.validationErrors">
                  {{ form.get("startTimeOnly").errors?.validationErrors}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-6">
              <mat-form-field class="w-100">
                <mat-label>Cost</mat-label>
                <span matPrefix>$ &nbsp;</span>
                <input matInput name="cost" id="cost" placeholder="Cost" type="number" formControlName="cost" />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <course-select-create (courseEvent)="setCourseId($event)" (isLoadingEvent)="isLoading = $event"></course-select-create>
            </div>
            <div class="col-6">
              <mat-form-field class="w-100">
                <mat-label>Registration Code</mat-label>
                <input matInput name="registrationCode" placeholder="Registration Code"
                  formControlName="registrationCode" />
                <button matSuffix mat-icon-button aria-label="Refresh" (click)="generateRegistrationCode()">
                  <mat-icon>refresh</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <button mat-raised-button class="primary">Save</button>
            </div>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>